/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Junkeng } from "../Junkeng";

export class Junkeng__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_coin: string, overrides?: Overrides): Promise<Junkeng> {
    return super.deploy(_coin, overrides || {}) as Promise<Junkeng>;
  }
  getDeployTransaction(
    _coin: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_coin, overrides || {});
  }
  attach(address: string): Junkeng {
    return super.attach(address) as Junkeng;
  }
  connect(signer: Signer): Junkeng__factory {
    return super.connect(signer) as Junkeng__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Junkeng {
    return new Contract(address, _abi, signerOrProvider) as Junkeng;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_coin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "Disclosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Earned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "a_index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "b",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "b_index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Established",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "Joined",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "a_index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "a_handShape",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "b",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "b_index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "b_handShape",
        type: "uint8",
      },
    ],
    name: "Settled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrew",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_handShape",
        type: "uint8",
      },
    ],
    name: "disclose",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getCoinBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "coins",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOpponentStatus",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "handShape",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "streak",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "phase",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStatus",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "handShape",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "streak",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "phase",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "join",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506040516117ce3803806117ce8339818101604052602081101561003357600080fd5b5051600180546001600160a01b039092166001600160a01b031992831617905560008054909116331790556117618061006d6000396000f3fe608060405234801561001057600080fd5b50600436106100725760003560e01c8063b48b557011610050578063b48b557014610101578063b688a36314610109578063e4df85201461011157610072565b80633ccfd60b146100775780634e69d560146100815780638fca6874146100d2575b600080fd5b61007f610131565b005b6100896104b2565b604080516001600160a01b039098168852602088019690965260ff9485168787015260608701939093529216608085015260a084019190915260c0830152519081900360e00190f35b6100ef600480360360208110156100e857600080fd5b50356105f7565b60408051918252519081900360200190f35b61008961077c565b61007f610989565b61007f6004803603602081101561012757600080fd5b503560ff16610ed7565b60023360009081526003602052604090206001015460ff16600281111561015457fe5b141561033d57336000908152600360205260408120549061017482611557565b60025490915081101561033a5760006101c96002848154811061019357fe5b906000526020600020906003020160010154600284815481106101b257fe5b906000526020600020906003020160010154611568565b905061012c811115610338573360009081526003602052604081206001908101805460ff19169091179055600280548590811061020257fe5b6000918252602090912060039182020154600160a01b900460ff169081111561022757fe5b14158015610266575060006002838154811061023f57fe5b6000918252602090912060039182020154600160a01b900460ff169081111561026457fe5b145b156102e357336000818152600360208181526040808420600201805460018082018355600485529583902080549091019095019094559181529154815193845291830186905282810191909152517f6876fda64f1c65c9d3f597e85b191207e3b78c313b6797570007d3e8a08eed789181900360600190a16102f7565b336000908152600360205260408120600201555b60036002848154811061030657fe5b906000526020600020906003020160020160006101000a81548160ff0219169083600381111561033257fe5b02179055505b505b50505b3360009081526004602052604090205461039e576040805162461bcd60e51b815260206004820152600860248201527f4e6f20636f696e73000000000000000000000000000000000000000000000000604482015290519081900360640190fd5b336000818152600460208181526040808420805490859055600154855483517f23b872dd0000000000000000000000000000000000000000000000000000000081526001600160a01b039182169681019690965260248601979097526044850182905291519095909116936323b872dd936064808201949392918390030190829087803b15801561042e57600080fd5b505af1158015610442573d6000803e3d6000fd5b505050506040513d602081101561045857600080fd5b5050604080513381526020810183905281517fb244b9a17ad633c6e83b7983ee04320484956a68ddbe96a0b70dfca1cf19d723929181900390910190a1503360009081526003602081905260409091200180546001019055565b6000808080808080803360009081526003602052604090206001015460ff1660028111156104dc57fe5b1161052e576040805162461bcd60e51b815260206004820152600f60248201527f4e6f20726567697374726174696f6e0000000000000000000000000000000000604482015290519081900360640190fd5b3360008181526003602052604090205460028054929950909750908790811061055357fe5b600091825260209091206003918202016002015460ff169081111561057457fe5b94506002868154811061058357fe5b9060005260206000209060030201600101549350600286815481106105a457fe5b6000918252602090912060039182020154600160a01b900460ff16908111156105c957fe5b3360009081526003602081905260409091206002810154910154989997989697959691959094509092509050565b600060023360009081526003602052604090206001015460ff16600281111561061c57fe5b14156107665733600090815260036020526040902054600280828154811061064057fe5b600091825260209091206003918202016002015460ff169081111561066157fe5b14156107645760006106728261157d565b905060006106bc6002848154811061068657fe5b906000526020600020906003020160010154600284815481106106a557fe5b9060005260206000209060030201600101546115e8565b8503905061012c8111801561070357506000600284815481106106db57fe5b6000918252602090912060039182020154600160a01b900460ff169081111561070057fe5b14155b8015610740575060006002838154811061071957fe5b6000918252602090912060039182020154600160a01b900460ff169081111561073e57fe5b145b15610761573360009081526003602052604090206002015493909301600101925b50505b505b3360009081526004602052604090205401919050565b6000808080808080803360009081526003602052604090206001015460ff1660028111156107a657fe5b116107f8576040805162461bcd60e51b815260206004820152600f60248201527f4e6f20726567697374726174696f6e0000000000000000000000000000000000604482015290519081900360640190fd5b336000908152600360205260409020546108118161157d565b96506002878154811061082057fe5b6000918252602090912060039091020154600280546001600160a01b039092169950908890811061084d57fe5b600091825260209091206003918202016002015460ff169081111561086e57fe5b95506002878154811061087d57fe5b906000526020600020906003020160010154945060036000600289815481106108a257fe5b60009182526020808320600392830201546001600160a01b031684528301939093526040909101812060029081015481549096508a9081106108e057fe5b60009182526020808320600392830201546001600160a01b031684528301939093526040909101902001549150600280828154811061091b57fe5b600091825260209091206003918202016002015460ff169081111561093c57fe5b1015610949576000610972565b6002878154811061095657fe5b6000918252602090912060039091020154600160a01b900460ff165b600381111561097d57fe5b93505090919293949596565b60023360009081526003602052604090206001015460ff1660028111156109ac57fe5b1415610b5f5733600090815260036020526040812054906109cc82611557565b600254909150811015610b5c5760006109eb6002848154811061019357fe5b905061012c811115610b5a573360009081526003602052604081206001908101805460ff191690911790556002805485908110610a2457fe5b6000918252602090912060039182020154600160a01b900460ff1690811115610a4957fe5b14158015610a885750600060028381548110610a6157fe5b6000918252602090912060039182020154600160a01b900460ff1690811115610a8657fe5b145b15610b0557336000818152600360208181526040808420600201805460018082018355600485529583902080549091019095019094559181529154815193845291830186905282810191909152517f6876fda64f1c65c9d3f597e85b191207e3b78c313b6797570007d3e8a08eed789181900360600190a1610b19565b336000908152600360205260408120600201555b600360028481548110610b2857fe5b906000526020600020906003020160020160006101000a81548160ff02191690836003811115610b5457fe5b02179055505b505b50505b60013360009081526003602052604090206001015460ff166002811115610b8257fe5b1115610bd5576040805162461bcd60e51b815260206004820152601460248201527f416c726561647920706172746963697061746564000000000000000000000000604482015290519081900360640190fd5b600280546040805160808101825233815260006020820181815242938301939093526001606083018190528401855593909352825160038084027f405787fa12a823e0f2b7631cc41b3ba8828b3321ca811111fa75cd3aa3bb5ace0180546001600160a01b039093167fffffffffffffffffffffffff0000000000000000000000000000000000000000909316929092178083559251939493919283917fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff90911690600160a01b908490811115610ca857fe5b02179055506040820151816001015560608201518160020160006101000a81548160ff02191690836003811115610cdb57fe5b021790555060009150610ceb9050565b3360009081526003602052604090206001015460ff166002811115610d0c57fe5b1415610d88576040805160808101909152818152602081016002815260006020808301829052604092830182905233825260038152919020825181559082015160018083018054909160ff1990911690836002811115610d6857fe5b021790555060408201516002820155606090910151600390910155610da9565b336000908152600360205260409020818155600101805460ff191660021790555b604080513381526020810183905281517f49f8fa5eee2e3f21251c2e968640dcaef35cb9332429eb059bb3cd56ddc2533d929181900390910190a16002810660011415610eba576000610e056002600184038154811061068657fe5b90507fd599fddddd6f19ebc013f20b5a43b042ee5964d209a964274fab8977eb819c0860026001840381548110610e3857fe5b906000526020600020906003020160000160009054906101000a90046001600160a01b03166001840360028581548110610e6e57fe5b600091825260209182902060039091020154604080516001600160a01b0395861681529283019390935292909216828201526060820185905260808201849052519081900360a00190a1505b503360009081526003602081905260409091200180546001019055565b60013360009081526003602052604090206001015460ff166002811115610efa57fe5b11610f4c576040805162461bcd60e51b815260206004820152601060248201527f4e6f74207061727469636970616e747300000000000000000000000000000000604482015290519081900360640190fd5b3360009081526003602052604081205490610f668261157d565b9050600060028281548110610f7757fe5b60009182526020909120600390910201546001600160a01b03169050600160028481548110610fa257fe5b600091825260209091206003918202016002015460ff1690811115610fc357fe5b14611015576040805162461bcd60e51b815260206004820152601160248201527f416c726561647920646973636c6f736564000000000000000000000000000000604482015290519081900360640190fd5b60018460ff161015801561102d575060038460ff1611155b61107e576040805162461bcd60e51b815260206004820152601260248201527f496e76616c69642068616e642073686170650000000000000000000000000000604482015290519081900360640190fd5b60006110af6002858154811061109057fe5b906000526020600020906003020160010154600285815481106101b257fe5b905061012c811115611100576000600285815481106110ca57fe5b906000526020600020906003020160000160146101000a81548160ff021916908360038111156110f657fe5b021790555061114e565b8460ff16600381111561110f57fe5b6002858154811061111c57fe5b906000526020600020906003020160000160146101000a81548160ff0219169083600381111561114857fe5b02179055505b600280858154811061115c57fe5b906000526020600020906003020160020160006101000a81548160ff0219169083600381111561118857fe5b0217905550604080513381526020810186905281517f23a6200ad6fe186c45badcd285c34c438705aeb48f037b18133d21df2544ff76929181900390910190a160028084815481106111d657fe5b600091825260209091206003918202016002015460ff16908111156111f757fe5b1415611536577f13e26580722ac6f5336050b3e9fcd2db95f9313d74b4c00ceaf1017e0e159cec33856002878154811061122d57fe5b6000918252602090912060039182020154600160a01b900460ff169081111561125257fe5b85876002898154811061126157fe5b6000918252602090912060039182020154600160a01b900460ff169081111561128657fe5b604080516001600160a01b039788168152602081019690965260ff948516868201529290951660608501526080840152921660a082015290519081900360c00190a160006112d48585611600565b90508060000b6001141561138e5733600081815260036020818152604080842060028082018054600180820183556004875285892080549092018101909155958552918501805460ff1990811687179091556001600160a01b038b1687528387208087018054909216909617905593909301849055928490529054825193845290830188905282820152517f6876fda64f1c65c9d3f597e85b191207e3b78c313b6797570007d3e8a08eed789181900360600190a1611491565b8060000b6000191415611447576001600160a01b038316600081815260036020818152604080842060028082018054600180820183556004875285892080549092018101909155958552918501805460ff1990811687179091553387528387208087018054909216909617905593909301849055928490529054825193845290830187905282820152517f6876fda64f1c65c9d3f597e85b191207e3b78c313b6797570007d3e8a08eed789181900360600190a1611491565b336000908152600360205260408082206001808201805460ff19908116831790915560029283018590556001600160a01b0388168552928420808201805490941690911790925501555b6003600286815481106114a057fe5b906000526020600020906003020160020160006101000a81548160ff021916908360038111156114cc57fe5b02179055506003600285815481106114e057fe5b906000526020600020906003020160020160006101000a81548160ff0219169083600381111561150c57fe5b0217905550506001600160a01b038216600090815260036020819052604090912001805460010190555b50503360009081526003602081905260409091200180546001019055505050565b600119811660018281011601919050565b600061157483836115e8565b42039392505050565b60008061158983611557565b60025490915081106115e2576040805162461bcd60e51b815260206004820152601260248201527f4f70706f6e656e74206e6f742072656164790000000000000000000000000000604482015290519081900360640190fd5b92915050565b60008183116115f757816115f9565b825b9392505050565b60408051610100810182526000608080830182815260001960a0850181905260c0850181905260e085018190529084528451808301865260018082526020828101869052828801829052606080840185905281880193909352875180860189528281528082018590528089018790528084018390528789015287519485018852818552840152948201528084018290529282019290925260028054829190869081106116a857fe5b6000918252602090912060039182020154600160a01b900460ff16908111156116cd57fe5b60ff16600481106116da57fe5b6020020151600284815481106116ec57fe5b6000918252602090912060039182020154600160a01b900460ff169081111561171157fe5b60ff166004811061171e57fe5b602002015194935050505056fea2646970667358221220c42fd92f41fea1369a3ee5ddfa2784b53f62ed43405b30520b0efb337584bf0b64736f6c63430007060033";
